export default function SemaforoBadge({ score, semaforo, size = "md" }) {
  let s = semaforo;
  if (!s && typeof score === "number") {
    s = score >= 85 ? "verde" : score >= 70 ? "amarillo" : score > 0 ? "rojo" : "gris";
  }
  const map = {
    verde: "bg-emerald-50 text-emerald-700 ring-emerald-600/20",
    amarillo: "bg-amber-50 text-amber-700 ring-amber-600/20",
    rojo: "bg-red-50 text-red-700 ring-red-600/20",
    gris: "bg-stone-100 text-stone-600 ring-stone-400/20",
  };
  const dotMap = {
    verde: "bg-emerald-500",
    amarillo: "bg-amber-500",
    rojo: "bg-red-500",
    gris: "bg-stone-400",
  };
  const sizeCls = size === "lg" ? "px-3 py-1.5 text-sm" : "px-2 py-0.5 text-xs";
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full ring-1 ring-inset font-medium ${sizeCls} ${map[s] || map.gris}`}
      data-testid={`semaforo-${s}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${dotMap[s] || dotMap.gris}`} />
      {typeof score === "number" ? `${score.toFixed ? score.toFixed(1) : score}%` : (s || "Sin datos")}
    </span>
  );
}
